var BlockView = require('views/block/base-block-view');
var SurveyService = require('services/survey-service');
var EvaluationService = require('services/evaluation-service');
var PageService = require('services/page-service');
var ProgressService = require('services/progress-service');
var ContentProvider = require('services/content-provider');

var SurveyView = BlockView.extend({
  className: 'survey-content',
  initialize: function(options) {
    this.$el.hide();
    BlockView.prototype.initialize.apply(this, arguments);
    this.model.set('local', EF.options.local);
  },
  load: function() {
    this.delegate('click', '[data-navigate]', function(e) {
      e.preventDefault();
      ProgressService.saveLocalActivityProgress({
        'attempt': 1,
        'enrollment_id': EF.enrollment.get('id'),
        'grade': null,
        'passed': true,
        'slug': this.model.get('slug')
      }).done(() => EF.activityProgresses.fetch());
      this.finish();
    });
    this.delegate('click', '#survey_redirect_button', function(e) {
      ContentProvider.SurveyService.triggerSurvey(this);
    });
  },
  play: function() {
    // If we're local, we're done - mark the block complete and hide the element
    // Hiding in case the block is used on a menu and we let the user stay on the current page
    // If user should be navigated forward, can use the forwardOnComplete option of the page
    if(EF.options.local) {
      this.$el.show();
      if(this.model.get('surveyCompleted')) {
        this.finish();
      }
    } else {
      var surveySlug = this.model.get('slug');
      EvaluationService.refreshResponseSet(surveySlug).then(() => {
        const surveyCompleted = SurveyService.userHasCompletedSurvey(surveySlug) ||
          (EF.enrollment.get('demoMode') === 'preview') ||
          EvaluationService.shouldSkip(surveySlug);
        if (surveyCompleted) {
          this.finish();
        } else {
          this.$el.show();
          setTimeout(() => {
            if (this.model) {
              ContentProvider.SurveyService.triggerSurvey(this);
            }
          }, 2000);
        }
      });
    }
  },

  finish: function() {
    this.readyToGo();
    if(this.$el) {
      this.$el.hide();
    }
  },
});

module.exports = SurveyView;
